export default (options) => {
  let content = '';
  let checked = false;

  content =
    'As between Producer and Owner, all right, title and interest, including copyright, in and to the Master(s) and all work product, services, and materials provided by Producer in connection with this Agreement and the Master(s) are “works made for hire” for Owner under the U.S. Copyright Act.  ' +
    'To the extent Producer is deemed to have any ownership interest therein, Producer hereby irrevocably assigns all right, title and interest therein, including copyright, ' +
    'to Owner in perpetuity throughout the world and in all media now known or hereafter devised. ';

  if (options['consent'] === 0) {
    content +=
      'Producer shall not distribute, display, reproduce, or otherwise make use of the Master(s), in whole or in part, in any manner or for any purpose without prior written consent from Owner.';
  } else if (options['consent'] === 1) {
    content +=
      'Producer may distribute, display, reproduce, or otherwise make use of the Master(s), in whole or in part, in any manner or for solely for promotional purposes.';
  }

  checked =
    (options.composition === 0 || options.composition === 1) &&
    (options.consent === 0 || options.consent === 1);

  return { content, checked };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Ownership.js